import { useBreadcrumbs } from 'src/hooks/useBreadcrumbs';
import { useQCTaskHook } from '../hooks/useQCTask.hook';
import { QCTPageView } from './QCTPage.view';

export const QCTPage = () => {
  const {
    clinicalTrialId,
    taskId,
    patientData,
    patientDataIsLoading,
    visitName,
  } = useQCTaskHook();

  useBreadcrumbs(
    [
      ['QC List', 'qcTasks'],
      [patientData?.patientCode ?? '...', 'qcTaskInfo'],
      [visitName ?? '...', 'qcTaskInfo'],
      ['QCT QC', 'qcTaskQCT'],
    ],
    [clinicalTrialId ?? '', taskId ?? '']
  );

  if (!clinicalTrialId || !taskId) {
    return null;
  }

  return (
    <QCTPageView
      loading={patientDataIsLoading}
      clinicalTrialId={clinicalTrialId}
      taskId={taskId}
    />
  );
};
